<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsReport-keySkuInvMonitored',
  components: { PageTable },
}
</script>
